// Generated from the previous site's editorial articles.
// Run: node scripts/import-legacy-articles.mjs

export type LegacyArticle = {
  id: string;
  category: string;
  title: string;
  excerpt: string;
  date: string;
  readTime: string;
  toc: { id: string; label: string }[];
  bodyHtml: string;
};

export const legacyArticles = [
  {
    "id": "ahamo-guide",
    "category": "通信会社",
    "readTime": "12分",
    "excerpt": "月額2,970円、かけ放題でも4,070円。SIMのみ20,000ptと対象端末最大44,000円割引から、自分に合う申込み方法を選べます。",
    "title": "スマホ代を年48,360円減らせる？ ahamoは月2,970円・乗り換え20,000pt",
    "date": "2026.09.20",
    "toc": [
      {
        "id": "section-1",
        "label": "こんな方は、比較候補に"
      },
      {
        "id": "section-2",
        "label": "こんな希望がある方は、先に確認を"
      },
      {
        "id": "section-3",
        "label": "通常料金の目安"
      },
      {
        "id": "section-4",
        "label": "料金表を見るときのポイント"
      },
      {
        "id": "section-5",
        "label": "申し込み前の順番"
      },
      {
        "id": "section-6",
        "label": "参照した公式情報"
      }
    ],
    "bodyHtml": "<p>地図やSNSだけでなく、外出先で動画も見る。短い電話もかける。そんな使い方なら、データと通話を一緒に見て選ぶ方法があります。</p><h2 id=\"section-1\">こんな方は、比較候補に</h2><p>月40GBに収まる使い方で、1回5分以内の国内通話が多い方。オンライン中心の手続きに対応できる方。</p><h2 id=\"section-2\">こんな希望がある方は、先に確認を</h2><p>毎月数GBしか使わない方は、小容量の候補も比較すると判断しやすくなります。長電話が多い方は、5分を超える通話の扱いと追加オプションを確認してください。</p><h2 id=\"section-3\">通常料金の目安</h2><p>税込・割引前の基本料金です。端末代、通話の追加料金、初期費用は別に考えます。2026年8月1日からのデータ増量おためしキャンペーン期間中は、申し込み不要で10GB増量されます。</p><div><table><thead><tr><th>プラン</th><th>月額</th><th>現在の容量</th><th>通話</th></tr></thead><tbody><tr><th scope=\"row\">ahamo</th><td>2,970円</td><td>40GB（通常30GB）</td><td>1回5分以内込み</td></tr><tr><th scope=\"row\">ahamo大盛り</th><td>4,950円</td><td>120GB（通常110GB）</td><td>1回5分以内込み</td></tr></tbody></table></div><h2 id=\"section-4\">料金表を見るときのポイント</h2><p>40GBで足りるか、120GBが必要かは実際の使用量で判断します。増量キャンペーンの終了後は、それぞれ通常の30GB・110GBに戻ります。</p><p>新規・乗り換えの事務手数料0円。店頭WEB手続き支援は別料金です。</p><p>店頭のWEB手続き支援は有料。端末操作は本人が行います。</p><h2 id=\"section-5\">申し込み前の順番</h2><ol><li>今の使用量と電話の使い方を確認する。</li><li>対応端末・エリア・キャンペーン実施状況を公式情報で確認する。</li><li>今の端末残債や家族への影響を整理してから、申込条件を確認する。</li></ol><p><a href=\"/compare\">通話や料金の条件も比べる →</a></p><p><a href=\"/diagnosis\">ほかの通信会社も含めて診断する →</a></p><h2 id=\"section-6\">参照した公式情報</h2><ul><li><a href=\"https://ahamo.com/plan/index.html\" target=\"_blank\" rel=\"noreferrer\">公式情報 1：プラン案内</a></li><li><a href=\"https://www.docomo.ne.jp/info/notice/page/260729_00.html\" target=\"_blank\" rel=\"noreferrer\">公式情報 2：データ増量おためしキャンペーン</a></li><li><a href=\"https://ahamo.com/support/index.html\" target=\"_blank\" rel=\"noreferrer\">公式情報 3：サポート条件</a></li></ul>"
  },
  {
    "id": "before-switching",
    "category": "はじめての乗り換え",
    "readTime": "8分",
    "excerpt": "乗り換え前に、請求・使用量・通話・家族割・引き継ぎを順番に確認します。",
    "title": "スマホ乗り換え前に確認したい5つ。申し込みより先に見ること",
    "date": "2026.09.18",
    "toc": [
      {
        "id": "section-1",
        "label": "1．請求額を「回線」と「端末」に分ける"
      },
      {
        "id": "section-2",
        "label": "2．契約容量ではなく、実際の使用量を見る"
      },
      {
        "id": "section-3",
        "label": "3．電話の長さと回数を確認する"
      },
      {
        "id": "section-4",
        "label": "4．家族と自宅ネットへの影響を見る"
      },
      {
        "id": "section-5",
        "label": "5．使い続けたいものを確認する"
      }
    ],
    "bodyHtml": "<p>新しい料金プランを決める前に、今の契約と使い方を整理しましょう。安く見えるプランでも、通話や端末代、家族の割引まで含めると判断が変わることがあります。</p><h2 id=\"section-1\">1．請求額を「回線」と「端末」に分ける</h2><p>請求書の合計だけでは、通信サービスの料金を比較できません。基本料金、通話料、オプション、端末の分割代金を分けて確認します。</p><p>乗り換えた後も端末の支払いが残るか、返却などの条件があるかは、現在の契約先で確認してください。端末代を含む今の請求額と、回線料金だけの新プランを比較しないようにしましょう。</p><h2 id=\"section-2\">2．契約容量ではなく、実際の使用量を見る</h2><p>直近数か月のデータ使用量を、契約先のマイページで確認します。自宅や職場のWi-Fiを使う月と、外出の多い月の両方が判断材料になります。</p><p>使用量が分からないときは、大容量が必要だと決めつけず、確認してから候補を絞る方法もあります。</p><h2 id=\"section-3\">3．電話の長さと回数を確認する</h2><p>短い電話を何度もかけるのか、長電話が多いのかによって、比較する通話オプションが変わります。基本料金と、必要な通話オプションを合計して考えます。</p><p>かけ放題の対象外となる番号や、専用アプリなどの利用条件も、候補の公式ページで確認してください。</p><h2 id=\"section-4\">4．家族と自宅ネットへの影響を見る</h2><p>自分の回線を変えたとき、家族の料金や自宅ネットとのセット割がどうなるか確認します。自分の月額だけではなく、影響を受ける契約を合計して比較することが大切です。</p><h2 id=\"section-5\">5．使い続けたいものを確認する</h2><ul><li>今の端末が、候補の通信会社で利用できるか。</li><li>普段使う場所が、サービスエリアに含まれるか。</li><li>契約名義と支払い方法が、申込条件に合うか。</li><li>現在のメールアドレスを継続できるか、変更が必要か。</li><li>店頭相談が必要か、オンラインで対応できるか。</li></ul><p>端末の対応可否は機種名だけでなく、購入元や型番まで確認します。手続きは申込先の最新案内に従ってください。</p><aside><strong>迷ったら、今の契約を続ける選択も。</strong><p>希望する料金・使い勝手・サポートを満たす候補がなければ、急いで変更する必要はありません。</p></aside><p><a href=\"/diagnosis\">使い方から候補を探す →</a></p><p>この記事は比較前の確認項目を整理したものです。個別サービスの契約条件を保証するものではありません。</p>"
  },
  {
    "id": "bill-basics",
    "category": "料金の見直し",
    "readTime": "10分",
    "excerpt": "スマホ代が高いと感じたら、合計額ではなく中身を確認。請求明細を4つに分け、見直す場所を見つける手順を解説します。",
    "title": "スマホ代が高い？ 請求明細を4つに分けると、見直す場所が分かる",
    "date": "2026.09.18",
    "toc": [
      {
        "id": "section-1",
        "label": "最初に用意するものは、3つだけ"
      },
      {
        "id": "bill-parts",
        "label": "同じ「スマホ代」でも、中身は違う"
      },
      {
        "id": "section-3",
        "label": "請求明細は、この順番で開く"
      },
      {
        "id": "section-4",
        "label": "明細の名前が違うときの早見表"
      },
      {
        "id": "section-5",
        "label": "契約中の通信会社で、確認画面を開く"
      },
      {
        "id": "old-plan",
        "label": "昔のプランだからこそ、見直す余地も"
      },
      {
        "id": "next-step",
        "label": "端末代が分からなくても、候補探しはできる"
      },
      {
        "id": "section-8",
        "label": "内訳が分かったら、次の一歩"
      }
    ],
    "bodyHtml": "<p>毎月の請求を見るたびに「もう少し安くならないかな」と思う。でも、何が高いのかはよく分からない。最初にすることは、いちばん安いプランを探すことより、今の支払いを分けて見ることです。</p><h2 id=\"section-1\">最初に用意するものは、3つだけ</h2><div><div><span>01</span><strong>契約中のスマホ</strong><p>通信会社のアプリや会員ページを開きます。</p></div><div><span>02</span><strong>直近3か月の明細</strong><p>1か月だけ高かった費用を見分けます。</p></div><div><span>03</span><strong>メモ</strong><p>基本料金・端末代・通話料・オプションを書きます。</p></div></div><p>紙の請求書がなくても大丈夫です。アプリや会員ページの「料金」「請求」「内訳」から確認できます。</p></section><aside><figcaption>請求は、4つに分けて見る</figcaption><div><div><span>01</span><strong>基本料金</strong><span>料金プラン・データ容量</span></div><div><span>02</span><strong>端末代</strong><span>分割代金・残債</span></div><div><span>03</span><strong>通話料</strong><span>従量料金・通話定額</span></div><div><span>04</span><strong>オプション</strong><span>補償・留守番電話など</span></div></div><p>新しいプランとは、基本料金と必要な通話料を中心に比べます。</p></aside><h2 id=\"bill-parts\">同じ「スマホ代」でも、中身は違う</h2><p>請求の合計には、通信プランの基本料金、電話の料金、端末の分割代金、有料オプションなどが含まれていることがあります。まず契約先の明細を開いて、どの項目にいくら払っているか見てみましょう。</p><p>たとえば、請求8,000円のうち端末代が3,000円なら、8,000円すべてを新しい通信プランと比べると差額が大きく見えてしまいます。これは説明用の仮例です。端末代以外にも項目があれば、それも分けて考えます。</p><section id=\"screen-steps\"><h2 id=\"section-3\">請求明細は、この順番で開く</h2><ol><li><span>1</span><div><strong>通信会社の公式アプリか会員ページを開く</strong><p>検索結果の広告ではなく、契約中の会社の公式アプリ・公式サイトからログインします。</p></div></li><li><span>2</span><div><strong>「料金」「請求額」「利用料金」を選ぶ</strong><p>トップ画面の合計額だけで終わらず、「内訳を見る」「詳細を確認」まで進みます。</p></div></li><li><span>3</span><div><strong>確認する月と電話番号を選ぶ</strong><p>家族分やインターネット料金がまとまっている場合は、自分の回線を選びます。</p></div></li><li><span>4</span><div><strong>4項目をメモする</strong><p>基本料金・端末代・通話料・有料オプションに分けます。名称が違う場合は下の早見表を使います。</p></div></li><li><span>5</span><div><strong>直近3か月を並べる</strong><p>毎月続く料金と、その月だけ発生した料金を分けて判断します。</p></div></li></ol><div><div><span>請求明細の画面イメージ</span><b>合計 8,000円</b></div><div><span>基本料金・データ</span><b>4,200円</b><em>通信料</em></div><div><span>端末分割支払金</span><b>3,000円</b><em>端末代</em></div><div><span>通話料</span><b>300円</b><em>通話料</em></div><div><span>補償・留守番電話</span><b>500円</b><em>オプション</em></div></div><p>実際の名称や表示順は通信会社・契約内容によって異なります。</p></section><aside><figcaption>たとえば、月8,000円の請求なら</figcaption><p>説明用の仮例：通信料と端末代だけの場合</p><div>毎月の支払い <strong>8,000<small>円</small></strong></div><div><div><span>通信料</span><strong>5,000<small>円</small></strong><em>新しいプランと比べる部分</em></div><div><span>端末代</span><strong>3,000<small>円</small></strong><em>残りの支払いを別に確認</em></div></div><p>8,000円の全額を、新しいプランの通信料と比べないことがポイントです。</p></aside><section><h2 id=\"section-4\">明細の名前が違うときの早見表</h2><div><table><thead><tr><th>分ける項目</th><th>明細に出やすい名前</th><th>確認すること</th></tr></thead><tbody><tr><th>基本料金</th><td>基本使用料、料金プラン、データ定額</td><td>新しい通信プランと比べる中心の金額</td></tr><tr><th>端末代</th><td>分割支払金、機種代金、端末購入代金</td><td>乗り換え後も支払いが残るか</td></tr><tr><th>通話料</th><td>音声通話料、国内通話料、通話オプション</td><td>従量料金か定額料金か</td></tr><tr><th>オプション</th><td>補償、留守番電話、セキュリティ、コンテンツ</td><td>今も必要か、解約条件があるか</td></tr></tbody></table></div><aside><strong>合計が合わなくても、慌てなくて大丈夫。</strong><p>税金、ユニバーサルサービス料、キャリア決済、家族回線、自宅インターネットなどが含まれる場合があります。「その他」として別にメモし、通信料へ無理に足さないようにします。</p></aside></section><section id=\"official-links\"><h2 id=\"section-5\">契約中の通信会社で、確認画面を開く</h2><p>画面名は変更されることがあります。下記は各社の公式案内です。ログイン後は「内訳」「詳しい内訳」「利用明細」まで進んでください。</p><div><a href=\"https://www.docomo.ne.jp/support/online_confirmation/\" target=\"_blank\" rel=\"noreferrer\"><strong>ドコモ</strong><span>My docomoで料金内訳を確認</span></a><a href=\"https://www.au.com/support/faq/details/00/0000/000003/pg00000350/\" target=\"_blank\" rel=\"noreferrer\"><strong>au・UQ mobile</strong><span>My au／My UQ mobileの案内</span></a><a href=\"https://www.softbank.jp/mobile/support/contract/charge-guide/procedure/online-charge/\" target=\"_blank\" rel=\"noreferrer\"><strong>SoftBank</strong><span>My SoftBankで請求内訳を確認</span></a><a href=\"https://www.ymobile.jp/support/online/billing/\" target=\"_blank\" rel=\"noreferrer\"><strong>Y!mobile</strong><span>My Y!mobileで詳しい内訳を確認</span></a><a href=\"https://network.mobile.rakuten.co.jp/guide/payment/usage-details/\" target=\"_blank\" rel=\"noreferrer\"><strong>楽天モバイル</strong><span>my 楽天モバイルで利用明細を確認</span></a></div><p>リンク先でID・パスワードや暗証番号を求められる場合があります。当サイトに契約情報を入力することはありません。</p></section><h2 id=\"old-plan\">昔のプランだからこそ、見直す余地も</h2><p>契約したときは合っていたプランでも、今はWi-Fiを使う時間が増えたり、電話をかけなくなったりしているかもしれません。長く使っている方は、プラン名と今の使い方を並べて見るところから始めてみてください。</p><p>受付が終わったプランを使っていることだけで、損だとは決められません。今の割引や家族への影響まで確かめてから判断しましょう。</p><h2 id=\"next-step\">端末代が分からなくても、候補探しはできる</h2><p>明細をすぐに見られなくても、使うデータ量と電話の使い方が分かれば、通信プランの候補を探せます。その時点では節約額を決めず、候補が見つかってから今の支払いと同じ範囲で比べれば大丈夫です。</p><section id=\"next-actions\"><h2 id=\"section-8\">内訳が分かったら、次の一歩</h2><p>ここまでで、通信料とそれ以外を分けられれば十分です。次にしたいことを選んでください。</p><div><a href=\"/bill-check\"><small>数字を整理したい</small><strong>支払い内訳ツールへ</strong><span>→</span></a><a href=\"/diagnosis\"><small>候補を知りたい</small><strong>3つの質問で診断する</strong><span>→</span></a></div><p><a href=\"/articles/before-switching\">乗り換え前に確認したい5つのこと →</a></p></section>"
  },
  {
    "id": "data-usage",
    "category": "データ容量",
    "readTime": "6分",
    "excerpt": "契約容量ではなく実際に使ったデータ量から、必要なギガ数を考えます。",
    "title": "何GBあれば足りる？ 契約容量より「使った量」を見よう",
    "date": "2026.09.18",
    "toc": [
      {
        "id": "section-1",
        "label": "まずは契約先のマイページを開く"
      },
      {
        "id": "section-2",
        "label": "1か月だけで決めない"
      },
      {
        "id": "section-3",
        "label": "これからの使い方も少しだけ考える"
      },
      {
        "id": "section-4",
        "label": "分からないときは、仮の候補から"
      }
    ],
    "bodyHtml": "<p>大容量のプランに入っているから、大容量が必要とは限りません。反対に、少ない容量に変えて毎月足りなくなるのも困ります。自分に合う容量は、最近の使い方から探してみましょう。</p><h2 id=\"section-1\">まずは契約先のマイページを開く</h2><p>アプリや会員ページで「データ使用量」「利用状況」などの項目を探します。契約できる上限ではなく、その月に実際に使った量を確認してください。表示場所や集計方法は契約先によって異なります。</p><h2 id=\"section-2\">1か月だけで決めない</h2><p>家で過ごした月と、旅行や外出が多かった月では使う量が変わります。確認できる範囲で数か月を見て、普段の月と多く使った月を把握しておくと、容量を選びやすくなります。</p><p>スマホ本体に表示される使用量を使うときは、集計の開始日も見てください。通信会社の請求期間とそろっていない数字を、そのまま1か月分として扱わないようにします。</p><h2 id=\"section-3\">これからの使い方も少しだけ考える</h2><p>通勤中に動画を見るようになる、外でパソコンをつなぐ機会が増えるなど、生活が変わる予定があれば、その分も判断材料になります。動画の画質などで消費量が変わるため、「何時間なら必ず何GB」とは決めつけません。</p><h2 id=\"section-4\">分からないときは、仮の候補から</h2><p>当サイトの診断は「分からない」でも進めます。その場合は20GBを仮定して候補を出します。あなたの使用量を推測できたという意味ではないので、申し込む前には実際の使用量を確認してください。</p><p>使用量が分かったら、その量を満たす選択肢で診断をやり直せます。50GBを超えていても、100GB程度で足りるのか、無制限を希望するのかで候補は変わります。</p><p><a href=\"/diagnosis\">使い方から候補を探す →</a></p><p><a href=\"/articles/before-switching\">乗り換え前に確認したい5つのこと →</a></p>"
  },
  {
    "id": "iijmio-guide",
    "category": "通信会社",
    "readTime": "13分",
    "excerpt": "2〜55GBの8段階とドコモ網・au網から選択可能。端末セット、通話、速度、キャンペーンまで具体的に解説します。",
    "title": "IIJmioは端末も安い。月950円の回線・キャンペーン・注意点を徹底解説",
    "date": "2026.09.20",
    "toc": [
      {
        "id": "section-1",
        "label": "こんな方は、比較候補に"
      },
      {
        "id": "section-2",
        "label": "こんな希望がある方は、先に確認を"
      },
      {
        "id": "section-3",
        "label": "通常料金の目安"
      },
      {
        "id": "section-4",
        "label": "料金表を見るときのポイント"
      },
      {
        "id": "section-5",
        "label": "申し込み前の順番"
      },
      {
        "id": "section-6",
        "label": "参照した公式情報"
      }
    ],
    "bodyHtml": "<p>Wi-Fi中心の日が多く、スマホのデータはそれほど使わない。そんな方は、まず小容量プランと必要な通話オプションの組み合わせを見てみましょう。</p><h2 id=\"section-1\">こんな方は、比較候補に</h2><p>データ使用量を把握していて、必要な容量を選びたい方。契約後の確認や相談をオンライン中心で進められる方。</p><h2 id=\"section-2\">こんな希望がある方は、先に確認を</h2><p>契約後も店頭で相談したい方は、サポート方法が希望に合うかを先に確認しましょう。無制限の使い放題を求める方も、容量の上限を確認する必要があります。</p><h2 id=\"section-3\">通常料金の目安</h2><p>税込・割引前の基本料金です。端末代、通話の追加料金、初期費用は別に考えます。当サイトで確認済みの容量・料金段階を抜粋しています。</p><div><table><thead><tr><th>プラン</th><th>月額</th><th>通話</th></tr></thead><tbody><tr><th scope=\"row\">ギガプラン 2GB</th><td>850円</td><td>通話定額は別途</td></tr><tr><th scope=\"row\">ギガプラン 5GB</th><td>950円</td><td>通話定額は別途</td></tr><tr><th scope=\"row\">ギガプラン 10GB</th><td>1,400円</td><td>通話定額は別途</td></tr><tr><th scope=\"row\">ギガプラン 15GB</th><td>1,600円</td><td>通話定額は別途</td></tr><tr><th scope=\"row\">ギガプラン 25GB</th><td>2,000円</td><td>通話定額は別途</td></tr></tbody></table></div><h2 id=\"section-4\">料金表を見るときのポイント</h2><p>電話をあまりかけない方と長電話をする方では、必要な通話オプションが変わります。基本料金だけで決めず、電話を含めた月額で比べてください。</p><p>通常初期費用3,300円＋SIM発行手数料。発行手数料はSIMの種類で異なります。</p><p>契約後の店頭サポートなし</p><h2 id=\"section-5\">申し込み前の順番</h2><ol><li>今の使用量と電話の使い方を確認する。</li><li>対応端末・エリア・サポート方法を公式情報で確認する。</li><li>今の端末残債や家族への影響を整理してから、申込条件を確認する。</li></ol><p><a href=\"../compare.html?brand=IIJmio#compare\">通話や割引の条件も比べる →</a></p><p><a href=\"/diagnosis\">ほかの通信会社も含めて診断する →</a></p><h2 id=\"section-6\">参照した公式情報</h2><ul><li><a href=\"https://www.iijmio.jp/gigaplan/\" target=\"_blank\" rel=\"noreferrer\">公式情報 1：プラン案内</a></li><li><a href=\"https://help.iijmio.jp/answer/602dc1d407f19b0012186e68/\" target=\"_blank\" rel=\"noreferrer\">公式情報 2：料金・通話・サポート条件</a></li><li><a href=\"https://www.iijmio.jp/hdc/spec/\" target=\"_blank\" rel=\"noreferrer\">公式情報 3：料金・通話・サポート条件</a></li><li><a href=\"https://help.iijmio.jp/answer/61172c8ab597a700193174ba/\" target=\"_blank\" rel=\"noreferrer\">公式情報 4：料金・通話・サポート条件</a></li></ul>"
  },
  {
    "id": "iphone-buy",
    "category": "端末購入",
    "readTime": "8分",
    "excerpt": "Apple、通信会社、量販店、中古販売店の違いを、総額と条件で比べます。",
    "title": "iPhoneはどこで買う？ Apple・通信会社・量販店・中古を比較",
    "date": "2026.09.18",
    "toc": [
      {
        "id": "section-1",
        "label": "まず、回線ごと変える必要があるか考える"
      },
      {
        "id": "section-2",
        "label": "Appleで買う：端末と回線を分けて選びたい人に"
      },
      {
        "id": "section-3",
        "label": "通信会社で買う：回線と購入条件をまとめて確認"
      },
      {
        "id": "section-4",
        "label": "家電量販店・中古販売店：商品ごとの条件を読む"
      },
      {
        "id": "section-5",
        "label": "比較メモは、この4つで十分"
      },
      {
        "id": "section-6",
        "label": "確認に使える公式情報"
      },
      {
        "id": "section-7",
        "label": "あわせて読みたい"
      }
    ],
    "bodyHtml": "<p>端末の購入先と、回線の契約先は分けて考えられます。まずは「手元に残して長く使うか」「返却を前提に使うか」を決めると、比較しやすくなります。</p><h2 id=\"section-1\">まず、回線ごと変える必要があるか考える</h2><p>今の回線に不満がなければ、端末だけ購入する方法から検討できます。格安SIMにしたい場合も、端末と回線を必ず同じ会社でそろえる必要はありません。購入前に、候補の通信会社の動作確認一覧で購入元・型番・SIMの種類を確認しましょう。</p></section><section id=\"section-1\"><h2 id=\"section-2\">Appleで買う：端末と回線を分けて選びたい人に</h2><p>AppleのオンラインストアやApple Storeで販売するiPhoneはSIMフリーです。使いたい機種と容量を選び、回線は別に比較できます。SIMフリーでも、すべての回線で全機能が使えるとは限りません。端末価格に加え、保証や必要なアクセサリも予算に入れておきましょう。</p></section><section id=\"section-2\"><h2 id=\"section-3\">通信会社で買う：回線と購入条件をまとめて確認</h2><p>機種変更や乗り換えと一緒に購入したい場合は、通信会社の販売条件を確認します。「月々の支払額」だけでなく、支払総額、回線契約の要否、返却期限、返却時の状態条件、返さない場合の支払いまで並べて比べましょう。返却するプランと、所有し続ける購入を同じものとして比べないことがポイントです。</p></section><section id=\"section-3\"><h2 id=\"section-4\">家電量販店・中古販売店：商品ごとの条件を読む</h2><p>回線契約が条件の価格か、端末単体の価格かを確認します。中古の場合は同じ機種でも、バッテリー・修理歴・保証・返品条件で選びやすさが変わります。価格だけで決めず、確認できない項目に販売店がどう対応するかも見ておきましょう。</p></section><section id=\"section-4\"><h2 id=\"section-5\">比較メモは、この4つで十分</h2><p>①欲しい機種・容量 ②端末に払う総額 ③返却や回線契約の条件 ④保証・返品の条件。この4つを同じ期間で整理します。購入先が決まったら回線の候補を探し、申し込み前に端末の対応を確認してください。サイトの料金診断は通信料の比較で、端末代は含みません。</p></section><h2 id=\"section-6\">確認に使える公式情報</h2><ul><li><a href=\"https://www.apple.com/jp/iphone/buy/\" target=\"_blank\" rel=\"noreferrer\">Apple：iPhoneの購入</a></li><li><a href=\"https://support.apple.com/ja-jp/iphone/repair\" target=\"_blank\" rel=\"noreferrer\">Apple：iPhoneのサービスと修理</a></li><li><a href=\"https://support.apple.com/ja-jp/104999\" target=\"_blank\" rel=\"noreferrer\">Apple：中古のiPhoneを購入する場合</a></li><li><a href=\"https://support.apple.com/ja-jp/109316\" target=\"_blank\" rel=\"noreferrer\">Apple：SIMロックの確認・解除</a></li></ul><aside><strong>端末と通信費を分けて見直す</strong><p><a href=\"/articles/bill-basics\">請求の内訳を確認する</a> → <a href=\"/bill-check\">請求整理ツールを使う</a> → <a href=\"/diagnosis\">通信料の候補を探す</a></p><p>申し込み前は<a href=\"/articles/before-switching\">乗り換え前の確認事項</a>へ。端末代や残債は診断結果に含まれません。</p></aside><h2 id=\"section-7\">あわせて読みたい</h2><ul><li><a href=\"/articles/iphone-repair-or-replace\">修理か買い替えか、どう決める？</a></li><li><a href=\"/articles/used-iphone-checklist\">中古iPhone購入前の確認7項目</a></li></ul><p>公式情報へのリンクは広告リンクではありません。価格やキャンペーンは掲載せず、選ぶ際の確認方法を整理しています。</p>"
  },
  {
    "id": "iphone-repair-or-replace",
    "category": "修理・買い替え",
    "readTime": "7分",
    "excerpt": "保証、修理見積もり、利用年数から、修理と買い替えを整理します。",
    "title": "iPhoneは修理か買い替えか？ 3つの基準で判断",
    "date": "2026.09.18",
    "toc": [
      {
        "id": "section-1",
        "label": "困っていることを、一つずつ分ける"
      },
      {
        "id": "section-2",
        "label": "先に、保証と修理の見積もりを確認する"
      },
      {
        "id": "section-3",
        "label": "修理を選びやすいケース"
      },
      {
        "id": "section-4",
        "label": "買い替えも比較したいケース"
      },
      {
        "id": "section-5",
        "label": "迷ったときは、二つの見積もりを並べる"
      },
      {
        "id": "section-6",
        "label": "確認に使える公式情報"
      },
      {
        "id": "section-7",
        "label": "あわせて読みたい"
      }
    ],
    "bodyHtml": "<p>充電がもたない。でも、それ以外には困っていない。そんなときは、買い替えを決める前に修理の見積もりを取りましょう。反対に、容量や使いたい機能にも不満があるなら、端末全体の見直しが役立ちます。</p><h2 id=\"section-1\">困っていることを、一つずつ分ける</h2><p>バッテリー、画面、カメラなどの故障と、保存容量の不足や欲しい機能を分けて書き出します。故障を直せば満足できるのか、直しても不満が残るのか。この違いが判断の出発点です。</p></section><section id=\"section-1\"><h2 id=\"section-2\">先に、保証と修理の見積もりを確認する</h2><p>Appleの修理案内で機種と症状を選び、利用中の保証・補償の適用も確認します。見積もりと実際の費用が異なる可能性があるため、受付先で確定条件を確認してください。修理中にスマホが必要なら、預かり期間や代替機も一緒に相談しましょう。</p></section><section id=\"section-2\"><h2 id=\"section-3\">修理を選びやすいケース</h2><p>困りごとが一か所に限られ、容量や機能に満足している場合です。「修理後にあとどれくらい使いたいか」を自分で決め、修理代をその期間で考えてみましょう。修理で将来の故障や利用期間が保証されるわけではありません。</p></section><section id=\"section-3\"><h2 id=\"section-4\">買い替えも比較したいケース</h2><p>複数の不具合がある、容量が足りない、必要なアプリや機能を使えない場合です。買い替え費用は本体価格だけでなく、今の端末の残債、保証、付属品、データ移行の費用も含めて整理します。下取りは査定条件があるので、確定前の金額を節約額として扱わないようにします。</p></section><section id=\"section-4\"><h2 id=\"section-5\">迷ったときは、二つの見積もりを並べる</h2><p>「今の端末を修理する費用」と「欲しい端末を買う費用」を用意すると、判断が具体的になります。どちらを選ぶ場合も、作業前にバックアップとデータ移行の準備を確認しましょう。通信費が高いことは別の問題なので、端末を使い続けながら回線だけ見直す方法もあります。</p></section><h2 id=\"section-6\">確認に使える公式情報</h2><ul><li><a href=\"https://www.apple.com/jp/iphone/buy/\" target=\"_blank\" rel=\"noreferrer\">Apple：iPhoneの購入</a></li><li><a href=\"https://support.apple.com/ja-jp/iphone/repair\" target=\"_blank\" rel=\"noreferrer\">Apple：iPhoneのサービスと修理</a></li><li><a href=\"https://support.apple.com/ja-jp/104999\" target=\"_blank\" rel=\"noreferrer\">Apple：中古のiPhoneを購入する場合</a></li><li><a href=\"https://support.apple.com/ja-jp/109316\" target=\"_blank\" rel=\"noreferrer\">Apple：SIMロックの確認・解除</a></li></ul><aside><strong>端末と通信費を分けて見直す</strong><p><a href=\"/articles/bill-basics\">請求の内訳を確認する</a> → <a href=\"/bill-check\">請求整理ツールを使う</a> → <a href=\"/diagnosis\">通信料の候補を探す</a></p><p>申し込み前は<a href=\"/articles/before-switching\">乗り換え前の確認事項</a>へ。端末代や残債は診断結果に含まれません。</p></aside><h2 id=\"section-7\">あわせて読みたい</h2><ul><li><a href=\"/articles/iphone-buy\">iPhoneはどこで買う？</a></li><li><a href=\"/articles/used-iphone-checklist\">中古iPhone購入前の確認7項目</a></li></ul><p>公式情報へのリンクは広告リンクではありません。価格やキャンペーンは掲載せず、選ぶ際の確認方法を整理しています。</p>"
  },
  {
    "id": "rakuten-guide",
    "category": "通信会社",
    "readTime": "6分",
    "excerpt": "月末のギガも、長電話の通話料も我慢しない。月1,078〜3,278円の料金、無料通話、最新iPhone 18 Proの特典を具体的に解説します。",
    "title": "ギガも長電話も我慢しない。楽天モバイルは月1,078〜3,278円＋iPhone 18 Pro特典",
    "date": "2026.09.18",
    "toc": [
      {
        "id": "section-1",
        "label": "こんな方は、比較候補に"
      },
      {
        "id": "section-2",
        "label": "こんな希望がある方は、先に確認を"
      },
      {
        "id": "section-3",
        "label": "通常料金の目安"
      },
      {
        "id": "section-4",
        "label": "料金表を見るときのポイント"
      },
      {
        "id": "section-5",
        "label": "申し込み前の順番"
      },
      {
        "id": "section-6",
        "label": "参照した公式情報"
      }
    ],
    "bodyHtml": "<p>月によって使うデータ量が変わる方は、使用量に応じて料金が変わるプランも候補になります。ただし、通信する場所と電話の使い方も一緒に確認しましょう。</p><h2 id=\"section-1\">こんな方は、比較候補に</h2><p>使用量に応じた料金を希望する方や、月20GBを超えて使う方。Rakuten Linkの条件を理解して利用できる方。</p><h2 id=\"section-2\">こんな希望がある方は、先に確認を</h2><p>標準の電話アプリだけで無料通話になると思っている方は、申し込み前に使い方の確認が必要です。よく使う場所のエリアや屋内の利用環境が不安な方も、料金だけで決めないようにしましょう。</p><h2 id=\"section-3\">通常料金の目安</h2><p>税込・割引前の基本料金です。端末代、通話の追加料金、初期費用は別に考えます。当サイトで確認済みの容量・料金段階を抜粋しています。</p><div><table><thead><tr><th>プラン</th><th>月額</th><th>通話</th></tr></thead><tbody><tr><th scope=\"row\">Rakuten最強プラン (~3GB)</th><td>1,078円</td><td>Rakuten Link利用が前提</td></tr><tr><th scope=\"row\">Rakuten最強プラン (3~20GB)</th><td>2,178円</td><td>Rakuten Link利用が前提</td></tr><tr><th scope=\"row\">Rakuten最強プラン (無制限)</th><td>3,278円</td><td>Rakuten Link利用が前提</td></tr></tbody></table></div><h2 id=\"section-4\">料金表を見るときのポイント</h2><p>診断ではRakuten Link利用を前提にしています。標準電話アプリや対象外番号の料金は別です。無制限にも利用条件があり、どこでも同じ速度を保証するものではありません。</p><p>同一名義の累計4回線目までは事務手数料無料。5回線目以降3,850円。</p><p>ショップで相談可能。対応できる手続き・有料サービスは店舗で確認。</p><h2 id=\"section-5\">申し込み前の順番</h2><ol><li>今の使用量と電話の使い方を確認する。</li><li>対応端末・エリア・サポート方法を公式情報で確認する。</li><li>今の端末残債や家族への影響を整理してから、申込条件を確認する。</li></ol><p><a href=\"../compare.html?brand=%E6%A5%BD%E5%A4%A9%E3%83%A2%E3%83%90%E3%82%A4%E3%83%AB#compare\">通話や割引の条件も比べる →</a></p><p><a href=\"/diagnosis\">ほかの通信会社も含めて診断する →</a></p><h2 id=\"section-6\">参照した公式情報</h2><ul><li><a href=\"https://network.mobile.rakuten.co.jp/fee/saikyo-plan/\" target=\"_blank\" rel=\"noreferrer\">公式情報 1：プラン案内</a></li><li><a href=\"https://network.mobile.rakuten.co.jp/fee/saikyo-plan/detail/\" target=\"_blank\" rel=\"noreferrer\">公式情報 2：料金・通話・サポート条件</a></li><li><a href=\"https://network.mobile.rakuten.co.jp/shop/\" target=\"_blank\" rel=\"noreferrer\">公式情報 3：料金・通話・サポート条件</a></li></ul>"
  },
  {
    "id": "used-iphone-checklist",
    "category": "中古端末",
    "readTime": "9分",
    "excerpt": "中古iPhone購入前に確認したい保証、回線対応、利用制限、バッテリーなど7項目です。",
    "title": "中古iPhoneで失敗しないための購入前チェック7項目",
    "date": "2026.09.18",
    "toc": [
      {
        "id": "section-1",
        "label": "1．販売者・返品・保証"
      },
      {
        "id": "section-2",
        "label": "2．アクティベーションロック"
      },
      {
        "id": "section-3",
        "label": "3．使う回線とSIMへの対応"
      },
      {
        "id": "section-4",
        "label": "4．ネットワーク利用制限"
      },
      {
        "id": "section-5",
        "label": "5．バッテリーと修理履歴"
      },
      {
        "id": "section-6",
        "label": "6．外観と基本動作"
      },
      {
        "id": "section-7",
        "label": "7．容量と購入後の費用"
      },
      {
        "id": "section-8",
        "label": "届いたら、返品期限までに確認する"
      },
      {
        "id": "section-9",
        "label": "確認に使える公式情報"
      },
      {
        "id": "section-10",
        "label": "あわせて読みたい"
      }
    ],
    "bodyHtml": "<p>同じ機種でも、一台ごとの状態は違います。販売ページで確認できることと、受け取り後に試すことを分けておくと、購入後の戸惑いを減らせます。</p><h2 id=\"section-1\">1．販売者・返品・保証</h2><p>返品できる期間と条件、故障時の窓口を購入前に確認します。届いてから不明点が出た場合の連絡先も控えておきましょう。</p></section><section id=\"section-1\"><h2 id=\"section-2\">2．アクティベーションロック</h2><p>以前の所有者のロックが残る端末は購入しないでください。初期化済みという説明だけでなく、設定を進められることを確認します。</p></section><section id=\"section-2\"><h2 id=\"section-3\">3．使う回線とSIMへの対応</h2><p>購入元・型番とSIMロックの状態、物理SIM／eSIMの対応を確認し、利用予定の通信会社の動作確認一覧と照合します。</p></section><section id=\"section-3\"><h2 id=\"section-4\">4．ネットワーク利用制限</h2><p>販売店に利用制限の確認結果と、購入後に制限された場合の保証を質問しましょう。端末のIMEIを使い、購入元の通信会社が提供する確認窓口で調べる方法もあります。確認時点の結果と将来の保証は別です。</p></section><section id=\"section-4\"><h2 id=\"section-5\">5．バッテリーと修理履歴</h2><p>設定で確認できるバッテリー状態や部品・修理履歴を見ます。表示できる情報は機種などで異なります。不明な項目は販売者に確認しましょう。</p></section><section id=\"section-5\"><h2 id=\"section-6\">6．外観と基本動作</h2><p>画面、ボタン、カメラ、音声、充電を試します。外観の傷だけで判断せず、日常で使う操作を受け取り後すぐに確かめましょう。</p></section><section id=\"section-6\"><h2 id=\"section-7\">7．容量と購入後の費用</h2><p>写真やアプリに必要な容量を選びます。本体に加え、必要な充電器や修理などの予算を足し、新品の候補とも比較してください。</p></section><section id=\"section-7\"><h2 id=\"section-8\">届いたら、返品期限までに確認する</h2><p>注文内容と実物を照合し、上の項目を順番に確認します。問題があれば販売者へ連絡し、返品条件に沿って対応しましょう。確認が済む前に古い端末を手放さず、データ移行後も必要な情報がそろったか確かめてください。</p></section><h2 id=\"section-9\">確認に使える公式情報</h2><ul><li><a href=\"https://www.apple.com/jp/iphone/buy/\" target=\"_blank\" rel=\"noreferrer\">Apple：iPhoneの購入</a></li><li><a href=\"https://support.apple.com/ja-jp/iphone/repair\" target=\"_blank\" rel=\"noreferrer\">Apple：iPhoneのサービスと修理</a></li><li><a href=\"https://support.apple.com/ja-jp/104999\" target=\"_blank\" rel=\"noreferrer\">Apple：中古のiPhoneを購入する場合</a></li><li><a href=\"https://support.apple.com/ja-jp/109316\" target=\"_blank\" rel=\"noreferrer\">Apple：SIMロックの確認・解除</a></li></ul><aside><strong>端末と通信費を分けて見直す</strong><p><a href=\"/articles/bill-basics\">請求の内訳を確認する</a> → <a href=\"/bill-check\">請求整理ツールを使う</a> → <a href=\"/diagnosis\">通信料の候補を探す</a></p><p>申し込み前は<a href=\"/articles/before-switching\">乗り換え前の確認事項</a>へ。端末代や残債は診断結果に含まれません。</p></aside><h2 id=\"section-10\">あわせて読みたい</h2><ul><li><a href=\"/articles/iphone-buy\">iPhoneはどこで買う？</a></li><li><a href=\"/articles/iphone-repair-or-replace\">修理か買い替えか、どう決める？</a></li></ul><p>公式情報へのリンクは広告リンクではありません。価格やキャンペーンは掲載せず、選ぶ際の確認方法を整理しています。</p>"
  }
] as LegacyArticle[];
